import { DocFlowTableRow } from '../../../DocFlowTableRow'
import { Container } from '../../Container'
import {
  getTableRowData,
  TABLE_ROW_COLUMNS_CONFIG,
} from '../DocumentStaplings.mock'

function DocumentStaplingsTableRow() {
  return (
    <>
      <Container label='Document stapling table row, without actions, all columns'>
        <DocFlowTableRow
          Actions={null}
          columns={TABLE_ROW_COLUMNS_CONFIG}
          item={getTableRowData()}
          selected={new Set()}
        />
      </Container>
      <Container label='Document stapling table row, with actions, all columns'>
        <DocFlowTableRow
          columns={TABLE_ROW_COLUMNS_CONFIG}
          item={getTableRowData()}
          selected={new Set()}
        />
      </Container>
    </>
  )
}

export default DocumentStaplingsTableRow
